export const isDev = ['localhost'].some(e => window.location.host.includes(e));
